import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";
import { safeNext } from "@/app/safe-next";
import { serverAuth } from "@/data/auth";
import { SignInPage } from "@/features/signin/SignInPage";
import { VisitorTours } from "@/tours/VisitorTours";

const search = z.object({
  step: z.enum(["link-sent", "2fa", "sso"]).optional(),
  state: z.enum(["loading", "empty", "error", "expired", "used", "wrong-code", "locked", "offline", "not-member", "provider-failed"]).optional(),
  error: z.string().max(40).optional(),
  // where a signed-out visit to a deep link goes after sign-in; anything but a path on this site is dropped
  next: z.unknown().transform(safeNext).optional(),
});

/** Sign in (P01). Public, so it sits outside `_app` and has no app shell. */
export const Route = createFileRoute("/sign-in")({
  validateSearch: search,
  // on the client dashboard's address a signed-out staff link lands here in the browser (Caddy only sees full loads), so
  // it forwards to the client sign-in and keeps the return path (route walk 2026-11-01)
  beforeLoad: async ({ search: s }) => {
    if (!serverAuth || typeof window === "undefined") return;
    const tenant = await fetch("/api/public/tenant")
      .then((r) => (r.ok ? (r.json() as Promise<{ clientUrl?: string | null }>) : null))
      .catch(() => null);
    if (!tenant?.clientUrl || new URL(tenant.clientUrl).origin !== window.location.origin) return;
    throw redirect({ href: s.next ? `/portal/sign-in?next=${encodeURIComponent(s.next)}` : "/portal/sign-in" });
  },
  component: () => (
    <VisitorTours>
      <SignInPage search={Route.useSearch()} />
    </VisitorTours>
  ),
});
